import globalStatis from './globalStatis'
import restaurantManage from './restaurantManage'
import terminalManage from './terminalManage'
import account from './account'

export default {
  globalStatis,
  restaurantManage,
  terminalManage,
  account
}



// WEBPACK FOOTER //
// ./src/store/modules/index.js